import React from 'react';
import './Signature.scss'; // Import the SCSS file

const Signature = ({ firstName, forDocument = false }) => {
  return forDocument ? (
    <div className="signatureDoc capitalize">
      {firstName}
    </div>
  ) : (
    <div className="signature capitalize">
      {firstName}
    </div>
  );
};

export default Signature;
